<template>
  <div
		style="margin: 10px;">
    <v-card
      ref="form"
      class="mx-auto mt-5"
      style="margin-bottom: 50px;"
      max-width="750">
      <span>
        <v-card-title>
          <v-spacer>Health History</v-spacer>
             <v-btn v-if='!user.complete'
            color="primary"
            @click="updateDB">Save</v-btn>
          <v-btn v-else
            color="primary"
            @click="updateDB">Update</v-btn>
        </v-card-title>
      </span>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>Name</v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-card-text>
              <v-text-field
                label="First Name"
                v-model="dataModel[0].fname"></v-text-field>
              <v-text-field
                label="Last Name"
                v-model="dataModel[0].lname"></v-text-field>
            </v-card-text>


          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Sex</v-expansion-panel-header>

          <v-expansion-panel-content>
            <GenderQuest
              :modifyData="dataModel"
              :modifyIndex="0"/>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Date of Birth</v-expansion-panel-header>

          <v-expansion-panel-content>
            <AgeQuest
              :data="dataModel"
              :modifyIndex="0"/>


          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Ancestry</v-expansion-panel-header>

          <v-expansion-panel-content>
            <AncestryQuest/>


          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel
          v-if='dataModel[0].gender === "Female"'>
          <v-expansion-panel-header>Reproductive Health</v-expansion-panel-header>

          <v-expansion-panel-content>
            <FemaleQuestions/>


          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Medical Conditions</v-expansion-panel-header>

          <v-expansion-panel-content>
            <CondTest
              :modifyData="dataModel"
              :modifyIndex="0"/>


          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Surgeries</v-expansion-panel-header>

          <v-expansion-panel-content>
            <Surgeries
              :modifyData="dataModel"
              :modifyIndex="0"/>


          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Medication</v-expansion-panel-header>

          <v-expansion-panel-content>
            <Medication/>


          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Medication Allergies</v-expansion-panel-header>

          <v-expansion-panel-content>
            <MedicationAlergy/>


          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Substance Exposures</v-expansion-panel-header>

          <v-expansion-panel-content>
            <Exposures/>


          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Additional Information</v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-card-text>
              <v-textarea
                v-model="dataModel[0].notes"
                outline
                name="input-7-4"
                label="Additional pertinent information."
                value></v-textarea>
            </v-card-text>


          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <!-- <v-card-actions></v-card-actions> -->
    </v-card>
  </div>
</template>

<script>
import FemaleQuestions from "../components/questionnaire/PatientFormComp/FemaleQuestions.vue";
import AgeQuest from "../components/questionnaire/PatientFormComp/AgeQuest.vue";
import GenderQuest from "../components/questionnaire/PatientFormComp/GenderQuest.vue";
import CondTest from "../components/questionnaire/PatientFormComp/CondTest.vue";
import Surgeries from "../components/questionnaire/PatientFormComp/Surgeries";
import Exposures from "../components/questionnaire/PatientFormComp/Exposures";
import Medication from "../components/questionnaire/PatientFormComp/Medication";
import MedicationAlergy from "../components/questionnaire/PatientFormComp/MedicationAlergy";
import AncestryQuest from "../components/questionnaire/PatientFormComp/AncestryQuest";
import Conditions from "../components/questionnaire/PatientFormComp/Conditions";
import { postReq } from '../helper/firestore';
import { mapFields } from 'vuex-map-fields';
import { editHealthHistory, editFamilyHistory } from '../helper/firestore';

export default {
  components : {
    FemaleQuestions,
    AgeQuest,
    GenderQuest,
    CondTest,
    Surgeries,
    Exposures,
    Medication,
    MedicationAlergy,
    AncestryQuest,
    Conditions
  },
  computed: {
    ...mapFields("patientQuestion", [
      "dataModel",
      "snackbar",
      "errorText",
      "genderList",
      "formID"
    ]),
    ...mapFields([
      'user',
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
    ])
  },
  data() {
    return {
    }
  },
  mounted() {

  },
  methods : {
    updateDB() {
      let failed = true
      this.dataModel[0].name = this.dataModel[0].fname + ' ' + this.dataModel[0].lname
      this.user.familyHistory = this.dataModel
      editFamilyHistory(this.dataModel, (res1) => {
        failed = (res1.status !== 200)
        editHealthHistory(this.user.health, (res2) => {
          failed = (res2.status !== 200) || failed
          if (failed) {
            this.snackBarType = "warning";
            this.snackBarshow =true;
            this.snackBarmessage = "Your information wasn't saved";
          } else {
            this.snackBarType = "success";
            this.snackBarshow =true;
            this.snackBarmessage = "Thank you for providing your family and health information. One of our genetic counselors will email you within one week to talk about next steps.";
          }
        })
      })
    }
  },
  // beforeRouteLeave (to, from, next) {
  //   this.updateDB()
  //   next()
  // }
}
</script>

<style>

</style>
